// extracted by mini-css-extract-plugin
export default {"export-data__wrapper":"Export_export-data__wrapper__R9yp+","export-data__wrapper-svg":"Export_export-data__wrapper-svg__ZBxRD"};